import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { AddOutlined, RemoveOutlined, RestartAlt } from "@mui/icons-material";
import { makeSxStyles } from "ui";
import useTimetableZoomStore from "../../../../state/timetable-zoom-store";

const TimetableZoomControls: React.FC = () => {
  const { zoomLevel, zoomIn, zoomOut, resetZoom, minZoom, maxZoom } =
    useTimetableZoomStore();
  const styles = useStyles();

  const zoomPercentage = Math.round(zoomLevel * 100);

  return (
    <Box sx={styles.container}>
      <Tooltip title="Zoom In">
        <IconButton
          onClick={() => zoomIn()}
          disabled={zoomLevel >= maxZoom}
          sx={styles.leftButton}
          size="small"
        >
          <AddOutlined sx={styles.icon} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Zoom Out">
        <IconButton
          onClick={() => zoomOut()}
          disabled={zoomLevel <= minZoom}
          sx={styles.middleButton}
          size="small"
        >
          <RemoveOutlined sx={styles.icon} />
        </IconButton>
      </Tooltip>

      <Tooltip title={`Reset Zoom (${zoomPercentage}%)`}>
        <IconButton onClick={resetZoom} sx={styles.rightButton} size="small">
          <RestartAlt sx={styles.icon} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

const useStyles = makeSxStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    gap: "1px",
    marginLeft: "8px",
  },
  leftButton: {
    backgroundColor: theme.palette.grey[600],
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: "6px 0 0 6px",
    width: "20px",
    height: "20px",
    "&:hover": {
      backgroundColor: theme.palette.grey[700],
    },
    "&:disabled": {
      backgroundColor: theme.palette.grey[900],
      opacity: 0.5,
    },
  },
  middleButton: {
    backgroundColor: theme.palette.grey[600],
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: "0",
    width: "20px",
    height: "20px",
    "&:hover": {
      backgroundColor: theme.palette.grey[700],
    },
    "&:disabled": {
      backgroundColor: theme.palette.grey[900],
      opacity: 0.5,
    },
  },
  rightButton: {
    backgroundColor: theme.palette.grey[600],
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: "0 6px 6px 0",
    width: "20px",
    height: "20px",
    "&:hover": {
      backgroundColor: theme.palette.grey[700],
    },
    "&:disabled": {
      backgroundColor: theme.palette.grey[900],
      opacity: 0.5,
    },
  },
  icon: {
    fontSize: "14px",
    color: theme.palette.grey[300],
  },
}));

export default TimetableZoomControls;
